<template>
	<div class="pui-form">
		<mtipobulto-modals :modelName="modelName"></mtipobulto-modals>
		<!--<pui-form-header
			v-if="modelLoaded"
			:showHeader="!isCreatingElement">
			<mtipobulto-form-header
				:modelPk="modelPk"
			></mtipobulto-form-header>
		</pui-form-header>-->
		<v-form class="mb-4 pb-4" ref="form" v-model="valid" lazy-validation @submit.prevent v-if="modelLoaded">
			<v-layout wrap class="pui-form-layout">
				<v-flex xs12 md12>
					<pui-field-set :title="getTitleDatos">
						<v-layout wrap>
							<!-- IDTIPBULTO -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`idtipbulto-mtipobulto`"
									v-model="model.idtipbulto"
									:label="$t('mtipobulto.idtipbulto')"
									disabled
									toplabel
									maxlength="10"
								></pui-text-field>
							</v-flex>
							<!-- CODTIPBULTOEDI -->
							<v-flex xs12 md1>
								<pui-text-field
									:id="`codtipbultoedi-mtipobulto`"
									v-model="model.codtipbultoedi"
									:label="$t('mtipobulto.codtipbultoedi')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="17"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- NAME -->
							<v-flex xs12 md4>
								<pui-text-field
									:id="`name-mtipobulto`"
									v-model="model.name"
									:label="$t('mtipobulto.name')"
									:disabled="formDisabled"
									required
									toplabel
									maxlength="30"
								></pui-text-field>
							</v-flex>
						</v-layout>
						<v-layout wrap>
							<!-- FECBAJA -->
							<v-flex xs12 md3>
								<pui-date-field
									:id="`fecbaja-mtipobulto`"
									v-model="model.fecbaja"
									:label="$t('mtipobulto.fecbaja')"
									:disabled="formDisabled"
									toplabel
									time
								></pui-date-field>
							</v-flex>
						</v-layout>
						<!-- MINI AUDIT -->
						<pui-form-mini-audit class="pl-2" :model="model" v-if="!isCreatingElement"></pui-form-mini-audit>
					</pui-field-set>
				</v-flex>
			</v-layout>

			<!-- Page Footer -->
			<pui-form-footer v-if="!isModalDialog">
				<pui-form-footer-btns
					:formDisabled="formDisabled"
					:saveDisabled="saving"
					:saveAndNew="saveAndNew"
					:saveAndUpdate="saveAndUpdate"
					:save="save"
					:back="back"
				></pui-form-footer-btns>
			</pui-form-footer>
		</v-form>
		<pui-form-loading v-else></pui-form-loading>
	</div>
</template>

<script>
import {PuiFormMethodsMixin} from '@Pui9Components';
import mtipobultoActions from './MtipobultoActions';
import mtipobultoModals from './MtipobultoModals.vue';

export default {
	name: 'mtipobulto-form',
	mixins: [PuiFormMethodsMixin],
	components: {
		'mtipobulto-modals': mtipobultoModals
	},
	data() {
		return {
			modelName: 'mtipobulto',
			actions: mtipobultoActions.formActions
		};
	},
	methods: {
		afterGetData() {
			// Do something after get data from server
		}
	},
	computed: {
		getTitleDatos() {
			return this.$t('form.mtipobulto');
		}
	},
	created() {}
};
</script>
